import { Controller } from "@hotwired/stimulus";
import { createPopper } from "@popperjs/core";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.popper = createPopper(this.element, this.menuTarget, {
      placement: "bottom-end",
      strategy: "fixed",
      modifiers: [
        {
          name: "preventOverflow",
          options: {
            altAxis: true,
          },
        },
      ],
    });

    this.listener = (ev) => {
      if (this.element !== ev.target && !this.element.contains(ev.target)) {
        this.menuTarget.classList.add("hidden");
      }
    };

    this.escapeListener = (ev) => {
      if (ev.key === "Escape") {
        this.menuTarget.classList.add("hidden");
      }
    };

    window.addEventListener("click", this.listener);
    window.addEventListener("keydown", this.escapeListener);

    window.addEventListener("turbo:load", () => {
      this.menuTarget.classList.add("hidden");
    });
  }

  disconnect() {
    window.removeEventListener("click", this.listener);
    window.removeEventListener("keydown", this.escapeListener);
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden");
    this.popper.update();
  }
}
